<template>
    <div class="fee-list" @click="() => handleRedirect(contents[0])">
        <div class="dark" :style="{ width: widths[0] }">{{ contents[1] }}</div>
        <div class="dark" :style="{ width: widths[1] }">{{  contents[2] }}</div>
        <div :style="{ width: widths[2] }">
            <div class="light">{{contents[3].split('||')[0]}}</div>
            <div class="dark">{{contents[3].split('||')[1]}}</div>
        </div>
        <div :style="{ width: widths[3] }">
            <div class="light">{{contents[4].split('-')[0]}}</div>
            <div class="dark">{{contents[4].split('-')[1]}}</div>
        </div>
        <div :style="{ width: widths[4] }">
            <div class="light">{{contents[5].split('&')[0]}}</div>
            <div class="dark">{{contents[5].split('&')[1]}}</div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'FeeList',
    props: {
        widths: Array,
        contents: Array,
        handleRedirect: Function
    }
}
</script>
<style lang="scss">
.fee-list {
    display: flex;
    padding: 16px 33px;
    border-bottom: 1px solid #EBF0F4;
    align-items: center;
    cursor: pointer;

    &:hover {
        background: rgba(255, 255, 255, 0.79);
    }

    .dark {
        /*font-family: 'lato-regular';*/
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 20px;
        color: #261940;
    }

  .light {
        /*font-family: 'lato-regular';*/
        font-style: normal;
        font-weight: normal;
        font-size: 12px;
        line-height: 25px;
        color: rgba(38, 25, 64, 0.6);
    }
}
</style>